<template>
    <LayoutSub className="company_content">
        <SubSection>
            <h1>
                다양한 산업 분야에서 전문성을 바탕으로 <strong class="c-red">혁신적인 솔루션</strong>을 제공하며,<br />
                상호 협력을 통해 <strong class="c-red">지속 가능한 성장을 추구</strong>합니다.
            </h1>
        </SubSection>
        <SubSection classList="p-0">
            <div class="section_2grid">
                <div class="gray_box">
                    <h2>
                        <img src="@/assets/easyshop_logo.png" alt="" />
                        <span>이지샵(주)</span>
                    </h2>
                    <p>
                        이지샵(주)은 중소상공인에게 희망을 주고 어려운 사업을 회복시켜주며 사업 성공과 
                        마음의 평안으로 행복하게 하는 디지털 금융 플랫폼으로서 사회적 책임을 다하고자 합니다.
                    </p>
                    <OrangeLineButton text="바로가기" href="https://www.easyshop.co.kr/" />
                </div>
                <div class="gray_box">
                    <h2>
                        <img src="@/assets/seoul_ip_logo.png" alt="" />
                        <span>서울투자파트너스</span>
                    </h2>
                    <p>
                        서울투자파트너스는 한국정보통신(주)의 자회사로 설립된 창업투자회사로써 한국을 대표하는 
                        서울 그리고 세계 속에 웅비하고 있는 서울처럼 한국을 대표할 수 있는 좋은 투자회사가 되고자 합니다.
                    </p>
                    <OrangeLineButton text="바로가기" href="http://www.seoulip.com" />
                </div>
            </div>
        </SubSection>
    </LayoutSub>
</template>
<script>
import OrangeLineButton from '@/components/OrangeLineButton.vue';
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
        OrangeLineButton,
    },
};
</script>
